export function toHex(color) {
    if (!color) return color;
    const m = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)/);
    if (!m) return color;
    const r = parseInt(m[1], 10);
    const g = parseInt(m[2], 10);
    const b = parseInt(m[3], 10);
    return `#${((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1)}`;
}

// BoxPlot band colors
export const BAND_RED = 'rgba(239, 68, 68, 0.4)';
export const BAND_YELLOW = 'rgba(234, 179, 8, 0.4)';
export const BAND_GREEN = 'rgba(34, 197, 94, 0.4)';

// Report styling colors
export const GREEN_HEADER = '#87c57d';
export const GREEN_HEADER_LIGHT = '#b4f1ab';
export const GROOVE_BORDER = '#c5c5c5';
export const ROW_NAME_BG = '#e7e7e7';
